import { Crud, HttpClient, httpClient, QueryParameter } from 'lib/HttpClient';
import { Voucher } from './models/VoucherModel';

class VoucherApi extends Crud {
    constructor(client: HttpClient) {
        super(client, import.meta.env.API_SERVER_URL, 'vouchers', {
            'x-api-version': '10'
        });
    }

    async getAllVouchers() {
        let nextKey: string;
        let endOfData = false;
        let loadedVouchers: Voucher[] = [];
        let ok = true;
        while (!endOfData) {
            try {
                const queryParameters: QueryParameter[] = nextKey
                    ? [{ key: 'startKey', value: nextKey }]
                    : [];
                const { body, ok: okResponse } = await this.getList({
                    queryParameters
                });
                if (!okResponse) {
                    throw new Error('Failed to fetch vouchers');
                }
                loadedVouchers = [
                    ...loadedVouchers,
                    ...body.items.map((item: Voucher) => ({
                        ...item,
                        id: item._id
                    }))
                ];
                nextKey = body.page.nextKey;
                if (!nextKey) {
                    endOfData = true;
                }
            } catch (error) {
                endOfData = true;
                ok = false;
                console.error(error);
            }
        }

        return { items: loadedVouchers, ok };
    }
}

export const voucherApi = new VoucherApi(httpClient);
